var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"py-5 text-center"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }